import { toast } from "extensions/toast";

import { request } from "common/components/request";
import { SET_NORMALIZING_CURRENCY } from "common/actions/common";

import { SET_SETTINGS } from "../reducers/user_merchant_settings";

export const GET_USER_MERCHANT_SETTINGS = function() {
    return (dispatch) => request("/merchant/:merchant_ref/user/settings").then((data) => {
        dispatch(SET_SETTINGS(data));
        
        if (data.default_currency) {
            dispatch(SET_NORMALIZING_CURRENCY({
                currency: data.default_currency,
                currency_source: "user-default"
            }));
        }
        
        return data;
    });
};

export const UPDATE_USER_MERCHANT_SETTINGS = function(updatedSetting) {
    return (dispatch, getState) => {
        const currentSettings = getState().user_merchant_settings;
        const data = {
            ...currentSettings,
            ...updatedSetting
        };
    
        dispatch(SET_SETTINGS(data));
        return request("/merchant/:merchant_ref/user/settings", { method: "PUT", data }).catch(() => {
            // Revert back on error and present a message
            dispatch(SET_SETTINGS(currentSettings));
            toast.error("There was an error saving your settings");
        });
    };
};

export const SET_USER_MERCHANT_SETTINGS = function(data) {
    return (dispatch) => dispatch(SET_SETTINGS(data));
};
